/** Helpers import section */
import axios from 'axios'

import {
	getAuthorizedRequestConfigurationUser,
	getAuthorizedRequestConfigurationUserFiles,
	getAuthorizedRequestConfigurationUserParameters,
	getUserNameClaim,
} from '../helpers/SessionHelper'

export const START_LOADING_REQUIREMENT_REQUESTS = 'START_LOADING_REQUIREMENT_REQUESTS'
export const IS_LOADING_REQUIREMENT_REQUEST = 'IS_LOADING_REQUIREMENT_REQUEST'
export const SET_REQUIREMENT_REQUESTS_LIST = 'SET_REQUIREMENT_REQUESTS_LIST'
export const SET_REQUIREMENT_REQUEST = 'SET_REQUIREMENT_REQUEST'
export const SET_REQUIREMENT_REQUESTS_COUNT = 'SET_REQUIREMENT_REQUESTS_COUNT'
export const CHANGE_REQUIREMENT_REQUESTS_SORT_CRITERIA = 'CHANGE_REQUIREMENT_REQUESTS_SORT_CRITERIA'
export const CHANGE_REQUIREMENT_REQUESTS_QUERY = 'CHANGE_REQUIREMENT_REQUESTS_QUERY'
export const CHANGE_REQUIREMENT_REQUESTS_PAGINATION = 'CHANGE_REQUIREMENT_REQUESTS_PAGINATION'
export const GET_INFORMATION_REQUIREMENT_REQUEST = 'GET_INFORMATION_REQUIREMENT_REQUEST'
export const UPDATE_REQUIREMENT_REQUEST = 'UPDATE_REQUIREMENT_REQUEST'
export const IS_SAVING_REQUIREMENT_REQUEST = 'IS_SAVING_REQUIREMENT_REQUEST'
export const ADD_SUPPLIER_TO_REQUIREMENT_REQUEST_DETAIL = 'ADD_SUPPLIER_TO_REQUIREMENT_REQUEST_DETAIL'
export const REMOVE_SUPPLIER_FROM_REQUIREMENT_REQUEST_DETAIL = 'REMOVE_SUPPLIER_FROM_REQUIREMENT_REQUEST_DETAIL'
export const UPDATE_PLOT_REQUIREMENT_REQUEST_DETAIL = 'UPDATE_PLOT_REQUIREMENT_REQUEST_DETAIL'
export const IS_UPDATING_PLOT_REQUIREMENT_REQUEST = 'IS_UPDATING_PLOT_REQUIREMENT_REQUEST'
export const DELETE_PLOT_REQUIREMENT_REQUEST_DETAIL = 'DELETE_PLOT_REQUIREMENT_REQUEST_DETAIL'
export const UPDATE_COMMENTS_REQUIREMENT_REQUEST_DETAIL = 'UPDATE_COMMENTS_REQUIREMENT_REQUEST_DETAIL'
export const ADD_FILE_REQUIREMENT_REQUEST_DETAIL = 'ADD_FILE_REQUIREMENT_REQUEST_DETAIL'
export const REMOVE_FILE_REQUIREMENT_REQUEST_DETAIL = 'REMOVE_FILE_REQUIREMENT_REQUEST_DETAIL'
export const ADD_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL = 'ADD_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL'
export const ADD_RMI_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL = 'ADD_RMI_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL'
export const REMOVE_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL = 'REMOVE_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL'

function isLoadingRequirementRequests(isLoading) {
	return {
		type: START_LOADING_REQUIREMENT_REQUESTS,
		isLoading: isLoading,
	}
}

function setRequirementRequestsList(requirementRequests) {
	return {
		type: SET_REQUIREMENT_REQUESTS_LIST,
		requirementRequests: requirementRequests,
	}
}

function startLoadRequirementRequest(isLoading) {
	return {
		type: IS_LOADING_REQUIREMENT_REQUEST,
		isLoadingRequirementRequest: isLoading,
	}
}

function setRequirementRequest(requirementRequest) {
	return {
		type: SET_REQUIREMENT_REQUEST,
		requirementRequest: requirementRequest,
	}
}

function setRequirementRequestsCount(count) {
	return {
		type: SET_REQUIREMENT_REQUESTS_COUNT,
		count,
	}
}

function getInformationRequirementRequest(requirementRequest) {
	return {
		type: GET_INFORMATION_REQUIREMENT_REQUEST,
		requirementRequest: requirementRequest,
	}
}

function isSavingRequirementRequest(isSaving) {
	return {
		type: IS_SAVING_REQUIREMENT_REQUEST,
		isSaving: isSaving,
	}
}

function updateRequirementRequest(requirementRequest) {
	return {
		type: UPDATE_REQUIREMENT_REQUEST,
		requirementRequest: requirementRequest,
	}
}

function addSupplierToDetail(detailToken, quote) {
	return {
		type: ADD_SUPPLIER_TO_REQUIREMENT_REQUEST_DETAIL,
		detailToken,
		quote,
	}
}

function removeSupplierFromDetail(detailToken, supplierToken) {
	return {
		type: REMOVE_SUPPLIER_FROM_REQUIREMENT_REQUEST_DETAIL,
		detailToken,
		supplierToken,
	}
}

function updatePlotInDetail(detailPlane) {
	return { type: UPDATE_PLOT_REQUIREMENT_REQUEST_DETAIL, detailPlane }
}

function isUpdatingPlot(isUpdating) {
	return { type: IS_UPDATING_PLOT_REQUIREMENT_REQUEST, isUpdating }
}

function deletePlotFromDetail(detailToken) {
	return { type: DELETE_PLOT_REQUIREMENT_REQUEST_DETAIL, detailToken }
}

function updateCommentsInDetail(partNumberDetail) {
	return { type: UPDATE_COMMENTS_REQUIREMENT_REQUEST_DETAIL, partNumberDetail }
}

function addFileToDetail(files, tokenPartNumber) {
	return { type: ADD_FILE_REQUIREMENT_REQUEST_DETAIL, files, tokenPartNumber }
}

function removeFileFromDetail(fileName, tokenPartNumber) {
	return { type: REMOVE_FILE_REQUIREMENT_REQUEST_DETAIL, fileName, tokenPartNumber }
}

function addSampleRequestToDetail(detailToken, supplierToken) {
	return { type: ADD_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL, detailToken, supplierToken }
}

function addRMISampleRequestToDetail(detailToken, supplierToken, rmi) {
	return { type: ADD_RMI_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL, detailToken, supplierToken, rmi }
}

function removeSampleRequestFromDetail(detailToken, supplierToken) {
	return { type: REMOVE_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL, detailToken, supplierToken }
}

export function loadRequirementRequestsFromBackEnd(query, orderBy, sortAscending, page, rowsPerPage) {
	return function (dispatch, getState) {
		dispatch(isLoadingRequirementRequests(true))

		let selectedCompany = getState().profile.get('selectedCompany')
		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		let supplierToken = undefined
		if (getState().oidc.user.profile && getState().oidc.user.profile.company_token) {
			supplierToken = getState().oidc.user.profile.company_token
		}
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/requirementrequest/list`
		let data = {
			CompanyToken: selectedCompany.get('token'),
			SupplierToken: supplierToken,
			SortBy: orderBy,
			SortAscending: sortAscending,
			Query: query,
			Page: `${page + 1}`,
			RowsPerPage: rowsPerPage,
		}
		return axios
			.post(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(setRequirementRequestsList(serverResponse.data))
				}
			})
			.catch((error) => {
				dispatch(isLoadingRequirementRequests(false))
				console.error('Error getting the requirement requests list', error.response)
			})
	}
}

export function getRequirementRequestsCount() {
	return function (dispatch, getState) {
		let selectedCompany = getState().profile.get('selectedCompany')
		let supplierToken = undefined
		if (getState().oidc.user.profile && getState().oidc.user.profile.company_token) {
			supplierToken = getState().oidc.user.profile.company_token
		}
		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/requirementrequest/count`
		let data = {
			CompanyToken: selectedCompany.get('token'),
			SupplierToken: supplierToken,
		}
		return axios
			.post(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(setRequirementRequestsCount(serverResponse.data))
				}
			})
			.catch((error) => {
				console.error('Error getting the requirement requests count', error.response)
			})
	}
}

export function loadRequirementRequestFromBackEnd(token) {
	return function (dispatch, getState) {
		dispatch(startLoadRequirementRequest(true))

		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/requirementrequest/${token}`

		return axios
			.get(endPoint, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(setRequirementRequest(serverResponse.data))
				}
			})
			.catch((error) => {
				console.error('Error to load requirement request', error.response)
				dispatch(startLoadRequirementRequest(false))
				return Promise.reject()
			})
	}
}

export function getRequirementRequestInformationFromBackend(folio) {
	return function (dispatch, getState) {
		dispatch(startLoadRequirementRequest(true))

		let user = getState().oidc.user
		let selectedCompany = getState().profile.get('selectedCompany')
		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/requirementrequest`
		let data = {
			Folio: folio,
			CompanyToken: selectedCompany.get('token'),
			CompanyIdentifier: selectedCompany.get('get_company_identifier'),
			CompanyCenter: selectedCompany.get('center'),
			CenterFin: selectedCompany.get('center_fin'),
			CreatorUserName: getUserNameClaim(user),
			CreateBy: user.profile.name,
		}

		return axios
			.post(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(getInformationRequirementRequest(serverResponse.data))
					return Promise.resolve(serverResponse.data)
				}
			})
			.catch((error) => {
				console.error('Error to get information from requirement request', error.response)
				dispatch(startLoadRequirementRequest(false))
				return Promise.reject()
			})
	}
}

export function addSupplierToRequirementRequestItem(detail, supplier) {
	return function (dispatch, getState) {
		let user = getState().oidc.user
		let selectedCompany = getState().profile.get('selectedCompany')
		let configuration = getAuthorizedRequestConfigurationUser(user)
		let data = {
			ProjectPartNumberToken: detail.token,
			CompanyToken: selectedCompany.get('token'),
			CompanyIdentifier: selectedCompany.get('get_company_identifier'),
			CreatorUserName: getUserNameClaim(user),
			CreateBy: user.profile.name,
			SupplierToken: supplier.token,
			SupplierName: supplier.name,
			SupplierNumber: supplier.code,
			SupplierCountry: supplier.country,
			Type: 3,
		}
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/quotes`
		return axios
			.post(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(addSupplierToDetail(detail.token, serverResponse.data))
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error adding supplier to requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function removeSupplierFromRequirementRequestItem(detail, supplierToken) {
	return function (dispatch, getState) {
		let selectedCompany = getState().profile.get('selectedCompany')
		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		const info = getState().requirementRequest.get('requirementRequestInformation')
		if (!info) return Promise.reject()
		let folio = info.get('folio')
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/quotes/${selectedCompany.get('token')}/folio/${folio}/supplier/${supplierToken}/partNumber/${detail.token}`
		return axios
			.delete(endPoint, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(removeSupplierFromDetail(detail.token, supplierToken))
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error removing supplier from requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function sendRequirementRequest() {
	return function (dispatch, getState) {
		dispatch(isSavingRequirementRequest(true))
		let user = getState().oidc.user
		let selectedCompany = getState().profile.get('selectedCompany')
		let configuration = getAuthorizedRequestConfigurationUser(user)
		const info = getState().requirementRequest.get('requirementRequestInformation')
		if (!info) { dispatch(isSavingRequirementRequest(false)); return Promise.reject() }
		let folio = info.get('folio')
		let companyToken = selectedCompany.get('token')
		let documentIdentifier = selectedCompany.get('document_identifier')
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/quotes/${folio}/company/${companyToken}/${documentIdentifier}/send`
		return axios
			.post(endPoint, {}, configuration)
			.then((serverResponse) => {
				dispatch(isSavingRequirementRequest(false))
				if (serverResponse.status === 200) {
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error sending requirement request', error.response)
				dispatch(isSavingRequirementRequest(false))
				return Promise.reject()
			})
	}
}

export function updateDetailPlotName(detailToken, planeName) {
	return (dispatch, getState) => {
		dispatch(isUpdatingPlot(true))
		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/partNumbers/plots`
		let data = { Name: planeName, TokenPartNumber: detailToken }
		return axios
			.post(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(updatePlotInDetail(serverResponse.data))
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error updating plot name in requirement request detail', error.response)
				dispatch(isUpdatingPlot(false))
				return Promise.reject()
			})
	}
}

export function deleteDetailPlotName(detailToken, planeName) {
	return (dispatch, getState) => {
		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/partNumbers/plots/remove`
		let data = { Name: planeName, TokenPartNumber: detailToken }
		return axios
			.post(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(deletePlotFromDetail(detailToken))
				}
			})
			.catch((error) => {
				console.error('Error deleting plot name in requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function onAddCommentToRequirementRequestDetail(item, comments) {
	return (dispatch, getState) => {
		let user = getState().oidc.user
		let configuration = getAuthorizedRequestConfigurationUser(user)
		let data = { Description: comments, PartNumberToken: item.token }
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/partnumber/project`
		return axios
			.put(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(updateCommentsInDetail(serverResponse.data))
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error adding comment to requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function onAddFilesToRequirementRequestDetail(files, tokenPartNumber) {
	return (dispatch, getState) => {
		let user = getState().oidc.user
		let configuration = getAuthorizedRequestConfigurationUserFiles(user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/partnumbers/upload/${tokenPartNumber}`
		let formData = new FormData()
		for (var index = 0; index < files.length; index++) {
			formData.append('file', files[index])
		}
		return axios
			.post(endPoint, formData, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(addFileToDetail(serverResponse.data, tokenPartNumber))
					return Promise.resolve('Ok')
				}
			})
			.catch((error) => {
				console.error('Error uploading file to requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function onRemoveFilesFromRequirementRequestDetail(fileName, tokenPartNumber) {
	return (dispatch, getState) => {
		let params = { name: fileName }
		let configuration = getAuthorizedRequestConfigurationUserParameters(getState().oidc.user, params)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/partnumber/remove/${tokenPartNumber}`
		return axios
			.delete(endPoint, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(removeFileFromDetail(fileName, tokenPartNumber))
					return Promise.resolve('Ok')
				}
			})
			.catch((error) => {
				console.error('Error removing file from requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function onAddSampleRequestToRequirementRequestDetail(partNumber, quote) {
	return (dispatch, getState) => {
		let user = getState().oidc.user
		let selectedCompany = getState().profile.get('selectedCompany')
		let configuration = getAuthorizedRequestConfigurationUser(user)
		let data = {
			ProjectPartNumberToken: partNumber.token,
			CompanyToken: selectedCompany.get('token'),
			CompanyIdentifier: selectedCompany.get('get_company_identifier'),
			CreatorUserName: getUserNameClaim(user),
			CreateBy: user.profile.name,
			SupplierToken: quote.supplier_token,
			SupplierName: quote.supplier_name,
			SupplierNumber: quote.supplier_code,
			IsRequieredRMI: quote.is_rmi_requiered,
		}
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/samplerequests`
		return axios
			.post(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(addSampleRequestToDetail(partNumber.token, quote.supplier_token))
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error adding sample request to requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function onAddRMISampleRequestToRequirementRequestDetail(partNumber, quote, rmi) {
	return (dispatch, getState) => {
		let user = getState().oidc.user
		let configuration = getAuthorizedRequestConfigurationUser(user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/samplerequests/${quote.supplier_token}/partNumber/${partNumber.token}/${rmi}`
		return axios
			.put(endPoint, null, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(addRMISampleRequestToDetail(partNumber.token, quote.supplier_token, rmi))
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error updating RMI for sample request in requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function onRemoveSampleRequestFromRequirementRequestDetail(partNumber, supplierToken) {
	return (dispatch, getState) => {
		let user = getState().oidc.user
		let configuration = getAuthorizedRequestConfigurationUser(user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/samplerequests/supplier/${supplierToken}/partNumber/${partNumber.token}`
		return axios
			.delete(endPoint, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(removeSampleRequestFromDetail(partNumber.token, supplierToken))
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error removing sample request from requirement request detail', error.response)
				return Promise.reject()
			})
	}
}

export function finalizeRequirementRequestFromBackend(token) {
	return (dispatch, getState) => {
		dispatch(isSavingRequirementRequest(true))
		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/projectdocument/closedproject/${token}`
		return axios
			.put(endPoint, null, configuration)
			.then((serverResponse) => {
				dispatch(isSavingRequirementRequest(false))
				if (serverResponse.status === 200) {
					return Promise.resolve()
				}
			})
			.catch((error) => {
				console.error('Error finalizing requirement request', error.response)
				dispatch(isSavingRequirementRequest(false))
				return Promise.reject()
			})
	}
}

export function updateDataRequirementRequestFromBackend(folio, companyToken) {
	return function (dispatch, getState) {
		dispatch(isSavingRequirementRequest(true))
		let data = {
			Folio: folio,
			CompanyToken: companyToken,
		}

		let configuration = getAuthorizedRequestConfigurationUser(getState().oidc.user)
		let endPoint = `${process.env.REACT_APP_SIP_DEVELOPMENT}/requirementrequest`
		return axios
			.put(endPoint, data, configuration)
			.then((serverResponse) => {
				if (serverResponse.status === 200) {
					dispatch(isSavingRequirementRequest(false))
					dispatch(updateRequirementRequest(serverResponse.data))
				}
			})
			.catch((error) => {
				console.error('Error update data of a requirement request', error.response)
				dispatch(isSavingRequirementRequest(false))
				return Promise.reject()
			})
	}
}
